/**
 * @generated SignedSource<<89f4e031a392fa2525e9d358a69762fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderUpdateInput = {
  competencies?: ReadonlyArray<PersonCompetencies> | null | undefined;
  cost?: number | null | undefined;
  custom_values?: PersonInputCustomValues | null | undefined;
  first_name: string;
  last_name: string;
  person_id: number;
  role_id: number;
  tags?: ReadonlyArray<string | null | undefined> | null | undefined;
  team_id?: number | null | undefined;
};
export type PersonCompetencies = {
  level?: number | null | undefined;
  skill: PersonSkill;
};
export type PersonSkill = {
  name: string;
};
export type PersonInputCustomValues = {
  checkbox?: ReadonlyArray<PersonInputCustomValuesCheckbox | null | undefined> | null | undefined;
  date?: ReadonlyArray<PersonInputCustomValuesDate | null | undefined> | null | undefined;
  select?: ReadonlyArray<PersonInputCustomValuesSelect | null | undefined> | null | undefined;
  text?: ReadonlyArray<PersonInputCustomValuesText | null | undefined> | null | undefined;
};
export type PersonInputCustomValuesCheckbox = {
  typeId: number;
  value: boolean;
};
export type PersonInputCustomValuesDate = {
  typeId: number;
  value?: string | null | undefined;
};
export type PersonInputCustomValuesSelect = {
  optionId: number;
  typeId: number;
};
export type PersonInputCustomValuesText = {
  typeId: number;
  value: string;
};
export type ReplacePlaceholderSuggestedPeopleInput = {
  placeholderId: number;
  suggestedPeopleIds: ReadonlyArray<number>;
};
export type PlaceholderUpdateMutation$variables = {
  input: PlaceholderUpdateInput;
  replacePlaceholderSuggestedPeopleInput: ReplacePlaceholderSuggestedPeopleInput;
};
export type PlaceholderUpdateMutation$data = {
  readonly action_placeholder_update: {
    readonly account: {
      readonly competencies: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly id: number;
      readonly people_tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly roles: ReadonlyArray<{
        readonly active: boolean;
        readonly contracts: ReadonlyArray<{
          readonly person: {
            readonly created_at: string;
            readonly first_name: string;
            readonly last_name: string;
            readonly placeholder_count: number;
          };
        }>;
        readonly default_hour_cost: number | null | undefined;
        readonly id: number;
        readonly name: string;
      }>;
      readonly skills: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly tags: ReadonlyArray<{
        readonly archived: boolean;
        readonly id: number;
        readonly model: string;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"TeamSelector_account">;
    } | null | undefined;
    readonly person: {
      readonly assignments: ReadonlyArray<{
        readonly id: number;
        readonly role_id: number;
      }>;
      readonly competencies: ReadonlyArray<{
        readonly id: number;
        readonly level: number | null | undefined;
        readonly person_id: number;
        readonly skill: {
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly contracts: ReadonlyArray<{
        readonly cost: number | null | undefined;
        readonly id: number;
        readonly role: {
          readonly id: number;
          readonly name: string;
        };
        readonly role_id: number;
      }>;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly first_name: string;
      readonly id: number;
      readonly last_name: string;
      readonly placeholder_suggestions: ReadonlyArray<{
        readonly suggested_person: {
          readonly id: number;
          readonly " $fragmentSpreads": FragmentRefs<"SuggestedPerson_person">;
        };
        readonly suggested_person_id: number;
      }>;
      readonly tags: any;
      readonly team: {
        readonly id: number;
        readonly name: string;
      } | null | undefined;
      readonly team_id: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly replacePlaceholderSuggestedPeople: {
    readonly suggestions: ReadonlyArray<{
      readonly suggestedPersonId: number;
    }>;
  };
};
export type PlaceholderUpdateMutation = {
  response: PlaceholderUpdateMutation$data;
  variables: PlaceholderUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "replacePlaceholderSuggestedPeopleInput"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "replacePlaceholderSuggestedPeopleInput"
    }
  ],
  "concreteType": "ReplacePlaceholderSuggestedPeoplePayload",
  "kind": "LinkedField",
  "name": "replacePlaceholderSuggestedPeople",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PlaceholderSuggestion",
      "kind": "LinkedField",
      "name": "suggestions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "suggestedPersonId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last_name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "assignments",
  "kind": "LinkedField",
  "name": "assignments",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v3/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "contracts",
  "kind": "LinkedField",
  "name": "contracts",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v8/*: any*/),
    {
      "alias": "cost",
      "args": null,
      "kind": "ScalarField",
      "name": "cost_private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "roles",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "competencies",
  "kind": "LinkedField",
  "name": "competencies",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "person_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "skills",
      "kind": "LinkedField",
      "name": "skill",
      "plural": false,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggested_person_id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_select_values",
  "kind": "LinkedField",
  "name": "custom_select_values",
  "plural": true,
  "selections": [
    {
      "alias": "optionId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_option_id",
      "storageKey": null
    },
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  (v3/*: any*/),
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "model",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "archived",
    "storageKey": null
  }
],
v22 = {
  "alias": "people_tags",
  "args": [
    {
      "kind": "Literal",
      "name": "where",
      "value": {
        "model": {
          "_eq": "person"
        }
      }
    }
  ],
  "concreteType": "tags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": "tags(where:{\"model\":{\"_eq\":\"person\"}})"
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "tags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v24 = [
  (v3/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "competencies",
  "kind": "LinkedField",
  "name": "competencies",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "skills",
  "kind": "LinkedField",
  "name": "skills",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "roles",
  "kind": "LinkedField",
  "name": "roles",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": "default_hour_cost",
      "args": null,
      "kind": "ScalarField",
      "name": "default_hour_cost_private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "created_at": "desc"
          }
        },
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "person": {
              "is_placeholder": {
                "_eq": true
              }
            }
          }
        }
      ],
      "concreteType": "contracts",
      "kind": "LinkedField",
      "name": "contracts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "people",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "placeholder_count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created_at",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "contracts(limit:1,order_by:{\"created_at\":\"desc\"},where:{\"person\":{\"is_placeholder\":{\"_eq\":true}}})"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaceholderUpdateMutation",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PlaceholderUpdateOutput",
        "kind": "LinkedField",
        "name": "action_placeholder_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "placeholder_suggestions",
                "kind": "LinkedField",
                "name": "placeholder_suggestions",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "suggested_person",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedPerson_person"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSelector_account"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaceholderUpdateMutation",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PlaceholderUpdateOutput",
        "kind": "LinkedField",
        "name": "action_placeholder_update",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "placeholder_suggestions",
                "kind": "LinkedField",
                "name": "placeholder_suggestions",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "suggested_person",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image_key",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "teams",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7671492b152f36df616e7cca0216e696",
    "id": null,
    "metadata": {},
    "name": "PlaceholderUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PlaceholderUpdateMutation(\n  $input: PlaceholderUpdateInput!\n  $replacePlaceholderSuggestedPeopleInput: ReplacePlaceholderSuggestedPeopleInput!\n) {\n  replacePlaceholderSuggestedPeople(input: $replacePlaceholderSuggestedPeopleInput) {\n    suggestions {\n      suggestedPersonId\n    }\n  }\n  action_placeholder_update(input: $input) {\n    person {\n      id\n      first_name\n      last_name\n      team_id\n      tags\n      assignments {\n        id\n        role_id\n      }\n      contracts {\n        id\n        role_id\n        cost: cost_private\n        role {\n          id\n          name\n        }\n      }\n      team {\n        id\n        name\n      }\n      competencies {\n        id\n        level\n        person_id\n        skill {\n          id\n          name\n        }\n      }\n      placeholder_suggestions {\n        suggested_person_id\n        suggested_person {\n          id\n          ...SuggestedPerson_person\n        }\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n    }\n    account {\n      id\n      people_tags: tags(where: {model: {_eq: \"person\"}}) {\n        id\n        name\n        model\n        archived\n      }\n      tags {\n        id\n        name\n        model\n        archived\n      }\n      competencies {\n        id\n      }\n      skills {\n        id\n      }\n      roles {\n        id\n        name\n        active\n        default_hour_cost: default_hour_cost_private\n        contracts(where: {person: {is_placeholder: {_eq: true}}}, limit: 1, order_by: {created_at: desc}) {\n          person {\n            first_name\n            last_name\n            placeholder_count\n            created_at\n          }\n        }\n      }\n      ...TeamSelector_account\n    }\n  }\n}\n\nfragment SuggestedPerson_person on people {\n  first_name\n  last_name\n  image_key\n}\n\nfragment TeamSelector_account on accounts {\n  id\n  teams {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e438d0e127060c9066cd772e66e1aab";

export default node;
